import { IncomeEquityData } from './../../income-wealth/model/income-equity-data';
import { ProfessionalData } from './../../professional-data/model/professional-data';
import { Address } from './../../address/model/address';
import { MaritalStatus } from './../../marital-status/model/marital-status-data';
import { PersonalData } from '../../personal-data/model/personal-data';
import { ProfileData } from '../../profile-data/model/profile-data';
import { ErrorData } from './error-data';
import { Situacao } from '../service/user-registration/model/user-registration.model';

export class RegistratioData {

    profileData?: ProfileData = new ProfileData();
    personalData?: PersonalData = new PersonalData();
    maritalStatus?: MaritalStatus = new MaritalStatus();
    address?: Address = new Address();
    professionalData?: ProfessionalData = new ProfessionalData();
    incomeEquity?: IncomeEquityData = new IncomeEquityData();
    errorData?: ErrorData = new ErrorData();
    idInvestor?: string;
    contaIon?: boolean;
    situacao?: Situacao
}
